import { Input } from "antd"
import React from "react"

export default function AntdInput({ id, placeholder, size, className, style, value, onChange }) {
   return (
      <Input
         placeholder={placeholder || "Enter value"}
         size={size || "large"}
         style={{ width: "100%", height: "44px" }}
         value={value}
         onChange={onChange}
      />
   )
}
